import { myAxios } from "./axios"

export function getContracts(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/company-contracts", config)
}
export function getContractsDropdown(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})
        },
    }
    return myAxios.get("/company-contracts/dropdown", config)
}

export function getContract(id) {
    return myAxios.get("/company-contracts/" + id)
}

export function addContract(data) {
    return myAxios.post("/company-contracts/create", data)
}

export function editContract(id, data) {
    return myAxios.put("/company-contracts/" + id + "/update", data)
}

export function deleteContract(id) {
    return myAxios.delete("/company-contracts/" + id + "/delete")
}

export function importFile(data) {
    return myAxios.post("/company-contracts/import", data)
}

export function assignContractToAdmin({data, contractId}) {
    return myAxios.put('/company-contracts/'+contractId+'/admins/assign',data)
}

export function getContractShifts(payload, { page, perPage }) {
    let config = {
      params: {
        page,
        perPage,
        ...(payload || {}),
      },
    }
    return myAxios.get("/contract-shifts", config)
}
